import { Injectable } from '@angular/core';
import {Subject} from '@node_modules/rxjs/internal/Subject';
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root'
})
export class PusherService {
  private subject: Subject<any> = new Subject<any>();

  private pusherClient: Pusher;

  constructor() {
    this.pusherClient = new Pusher('3434d9184c77a2106179', { cluster: 'eu' });
  }

  getNewMessages(user_id) {
    const channel = this.pusherClient.subscribe('recipient_' + user_id);
    // console.log(channel, user_id);
    channel.bind('new_message', (data: any) => {
        // console.log(data);
        this.subject.next(data);
      }
    );
    return this.subject.asObservable();
  }

  updateSubscritpions(user_id) {
    const channel = this.pusherClient.subscribe('recipient_' + user_id);

    channel.bind('subscription_updated', (data: any) => {
        // console.log(data);
        this.subject.next(data);
      }
    );
    return this.subject.asObservable();
  }
}
